export const parseResourceStatus = isActive => (isActive ? 'Ativo' : 'Inativo')
